import { GRAPHQL } from '../constants';

export const PERK_QUERY = `
  _updatedAt
  _id
  id: _id
  category
  descriptionTeaser
  ${GRAPHQL.SLUG}
  offeredBy {
    name
    logo {
      asset {
        _id
        path
      }
    }
    legalName
  }
  ${GRAPHQL.IMAGE_OBJECT}
  name
  ${GRAPHQL.RELEASE}
  slogan
  termsAndConditionsRaw
  ${GRAPHQL.URL_OBJECT}
`;
